<div class="offcanvas-header">
    <h5 class="offcanvas-title">Pending Appointments</h5>
    <button
        type="button"
        class="btn-close text-reset"
        aria-label="Close"
        (click)="activeOffcanvas.dismiss('Cross click')"></button>
</div>
<div class="offcanvas-body">
    <div class="mb-3" #header>
        <ng-select
            [items]="appointmentStore.staff()"
            bindLabel="fullName"
            bindValue="id"
            [ngModel]="selectedStaffId"
            (change)="onSelectStaff($event)"></ng-select>
    </div>

    <div class="d-grid mb-3">
        <button
            sfButton
            type="button"
            size="lg"
            color="primary"
            [disabled]="appStore.me()?.id === selectedStaffId"
            (click)="selectMe()">
            Show Mine
        </button>
    </div>

    @for (appointment of appointmentStore.appointmentsPaged()?.items; track appointment.id) {
        <sf-appointment-card class="mb-1" [appointment]="appointment" [hideTitle]="true"></sf-appointment-card>
    } @empty {
        <sf-empty message="No pending appointments"></sf-empty>
    }

    @if (appointmentStore.appointmentsPaged(); as paged) {
        <sf-pagination-detail [paginationData]="paged" (onPageChange)="onPageChange($event)"></sf-pagination-detail>
    }

    <div class="d-grid mt-3">
        <button sfButton type="button" size="lg" color="dark" (click)="activeOffcanvas.close('Close click')">
            Close
        </button>
    </div>
</div>
